export default {
  certificate_title: 'Certificado de Calibração',
  requestor_data: 'Dados do Solicitante',
  contractor: 'Contratante',
  requester: 'Solicitante',
  order_service: 'Ficha de Acompanhamento',
  calibration_date: 'Data de Calibração',
  receipt_date: 'Data de Recebimento',
  emission_date: 'Data de Emissão',
  equipment_data: 'Dados do Equipamento',
  name: 'Denominação',
  manufacturer: 'Fabricante',
  model: 'Modelo',
  serial_number: 'Número de Série',
  code: 'Código',
  type_indication: 'Tipo de Indicação',
  software: 'Software',
  procedure: 'Procedimento',
  results_table: 'Tabela de Resultados',
  unit: 'Unidade',
  indication_equipment: 'Indicação do Equipamento Calibrado',
  reference_value: 'Valor de Referência',
  measurement_error: 'Erro de Medição',
  hysteresis: 'Histerese',
  uncertainty_measurement: 'Incerteza de Medição',
  bias_chart: 'Gráfico de Tendência',
  traceability_standards: 'Rastreabilidade dos Padrões Utilizados',
  calibration_location: 'Local de Calibração',
  temperature: 'Temperatura',
  relative_humidity: 'Umidade Relativa',
  information: 'Informações',
  ambient_conditions: 'Condições Ambientais e Local',
  digital_authorization: 'Autorização Digital por',
  authorized_signatory: 'Signatário Autorizado',
  replaced_certificate: 'Este certificado cancela e substitui o certificado Nº',
  settings: 'Configurações',
  input_signal: 'Sinal de Entrada',
  smallest_graduation: 'Valor da Menor Divisão',
  measurement_range: 'Intervalo de Medição',
  certificate_code: 'certificado código',
  next_calibration_in: 'próxima calibração em',
  no_Equipment_type: 'Sem Tipo de Instrumento',
  no_certificate: 'sem certificado',
  of_preposition: 'de',
  inProgress: 'Em Andamento',
  canceled: 'Cancelado',
  pending_signature: 'Pendente Assinatura',
  calibration_point: 'Ponto de Calibração',
  proc_26_obs: `A incerteza expadida de medição relatada é declarada com incerteza padrão de medição multiplicada pelo fator de abrangência k, o qual para uma distribuição  t com veff graus de liberade efetivos corresponde a uma probabilidade de abrangência de aproximadamente 95% A incerteza padrão da medição foi determinada de acordo com a publicação E A-4/02.
Erro de Medição é obtido pela diferença entre a Indicação do Instrumento em Calibração e o valor de referência

Histerese é a diferença entre os erros de indicação pontuais da escala dos ciclos ascendentes e descentes
Os valores de temperatura apresentados estão baseados na escala internacional de temperatura de 1990 (ITS-90)

A Cgcre é signatária do Acordo de Reconhecimento Mútuo da ILAC - International Laboratory Accreditation Cooperation

Este documento é válido exclusivamente para o equipamento avaliado, descrito nas condições específicas, não sendo extensivo a quaisquer lotes, mesmo que similares. Não é permitida a reprodução deste documento, somente original. Documento conferido e assinado eletronicamente.                   `,
  section_7_incerteza: 'A incerteza expadida de medição relatada é declarada com incerteza padrão de medição multiplicada pelo fator de abrangência k, o qual para uma distribuição  t com veff graus de liberade efetivos corresponde a uma probabilidade de abrangência de aproximadamente 95% A incerteza padrão da medição foi determinada de acordo com a publicação E A-4/02.',
  section_7_erro_medicao: 'Erro de Medição é obtido pela diferença entre a Indicação do Instrumento em Calibração e o valor de referência',
  section_7_values_temperature: 'Os valores de temperatura apresentados estão baseados na escala internacional de temperatura de 1990 (ITS-90)',
  section_7_signature: 'A Cgcre é signatária do Acordo de Reconhecimento Mútuo da ILAC - International Laboratory Accreditation Cooperation',
  section_7_valid_document: 'Este documento é válido exclusivamente para o equipamento avaliado, descrito nas condições específicas, não sendo extensivo a quaisquer lotes, mesmo que similares. Não é permitida a reprodução deste documento, somente original. Documento conferido e assinado eletronicamente.',
  sensor_diameter: 'Diâmetro do Sensor',
  sensor_length: 'Comprimento do Sensor',
  immersion_depht: 'Profundidade de Imersão',
  spectral_range: 'Faixa Espectral',
  proportion_ds: 'Proporção D:S',
  indicacao_item_calibrado: "Inducação do item calibrado",
  erro_histerese: "O erro de histerese é obtido pela maior diferença entre os erros, nos sentidos de avanço e retorno, num mesmo ponto da escala.",
  erro_sentido_avanco: "O erro do sentido de avanço é obtido pela diferença entre os erros máximo e mínimo, considerando apenas o sentido de avanço (para dentro) da haste móvel.",
  erro_sentido_avanco_retorno: "O erro dos sentidos de avanço e retorno é obtido pela diferença entre os erros máximo e mínimo, considerando os sentidos de avanço (para dentro) e retorno (para fora) da haste móvel do instrumento.",
  distance: 'Distância',
  size: 'Tamanho',
  type: 'Tipo',
  calculated_constant: 'Constante calculada',
  sensor_code: 'Código do sensor',
  seccion_diameter: 'Diâmetro da Seção',
  emissivity: 'Emissividade',
  gravity_acceleration: 'Aceleração da Gravidade',
  air_density: 'Densidade do Ar',
  atmospheric_pressure: 'Pressão Atmosférica',
  standard_temperature: 'Temperatura de Referência',
  standard_pressure: 'Pressão de Referência (hPa)',
  operation_principle: 'Príncipio de Funcionamento',
  standard: 'Norma',
  classe: 'Classe',
  frequence: 'Frequência Ref. (Hz)',
  nominal_value: 'Valor Nominal',
  lower_limit: 'Limite Inferior',
  upper_limit: 'Limite Superior',
  connection: 'Ligação',
  imersion: 'Imersão',
  thermometric_liquid: 'Líquido Termômetrico',
  estimated_resolution: 'Resolução Estimada',
  sensor_temperature: 'Sensor',
  material: 'Material',
  sample_material: 'Material da Amostra',
  batch: 'Lote',
  resolution: 'Resolução',
  measuring_position: 'Posição de medição',
  calibration_temperature: 'Temperatura de Calibração',
  simulation_temperature: 'Temperatura de Simulação',
  reference_information: 'Informações de referência',
  indicador_data: 'Dados do Indicador',
  electrode_data: 'Dados do Eletrodo',
  technical_specification_standard: 'Norma de especificação técnica',
  reference_sound_pressure_level: 'Nível de pressão sonora referência',
  microphone_data: 'Dados do Microfone',
  preamplifier_data: 'Dados do Pré-Amplificador',
  limit: 'Limite',
  detour: 'Desvio',
  sinal: 'Sinal',
  parameter: 'Parâmetro',
  secction_7_additional_information: 'Informações Adicionais referente as condições de calibração',
  reference_standard_for_calibration: 'Norma de referência para calibração',
  self_generated_noise_microphone_installed: 'Ruído autogerado com microfone instalado',
  c_weighted_frequency_with_microphone_installed: 'Curva de ponderação em frequência C, com microfone instado',
  c_weighted_frequency: 'Curva de ponderação em frequência C',
  a_weighted_frequency: 'Curva de ponderação em frequência A',
  level_linearity_on_the_reference_level_range: 'Linearidade na faixa de referência',
  toneburst_response_fast: 'Resposta a pulsos tonais na ponderação temporal F',
  toneburst_response_slow: 'Resposta a pulsos tonais na ponderação temporal S',
  c_weighted_peak_sound_level_8_Hz: 'Nível sonoro de pico ponderado em C, na frequência de 8 kHz',
  c_weighted_peak_sound_level_500_Hz: 'Nível sonoro de pico ponderado em C, na frequência de 500 kHz',
  overload_indication: 'Indicação de sobrecarga',
  self_generated: 'Ruído autogerado com dispositivo acoplado',
  frequency_and_time_weightings_at_1_kHz: 'Ponderação no Tempo e na Frequência em 1kHz',
  cell_constant: 'Constante da Célula Kcel',
  ph_simulation: 'Simulação em condutividade',
  unit_measurement: 'Unidade de Medida',
  obtaining_the_value_of_the_conductivity_cell_constant_kcal: 'Obtenção do valor da constante da célula de condutividade (Kcal)',
  obtaining_conductivity_with_mcr: 'Obtenção da condutuvidade com MRC',
  mrc_reference_value: 'Valor de referência do MRC',
  commercial_conductivity_cell_constant_value_kcel: 'Valor da contante da célula de condutividade comercial Kcel',
  conductivity_cell_constant_value_obtained_after_kcal_calibration: 'Valor da constante da célula de condutividade obtido após a calibração Kcal',
  section_7_conductivity_cell_constant_kcel_commercial_conductivity_cell_constant_value: 'Constante da célula de condutividade (Kcel): Valor da constante da célula de condutividade comercial',
  section_7_conductivity_cell_constant_kcal_cell_constant_value_obtained_after_calibration_with_mrc: 'Constante da célula de condutividade (Kcal): Valor da constante da célula, obtido pós a calibração com MRC',
  vertical_resolution: 'Resolução Vertical',
  horizontal_resolution: 'Resolução Horizontal',
  channel: 'Canal',
  position: 'Posição',
  specification: 'Especificação',
  value_obtained: 'Valor obtido',
  distance_from_nominal_value: 'Afastamento do valor nominal',
  thermal_expansion_coefficient: 'Coeficiente de expansão térmica',
  quantity_items: 'Quantidade de itens',
  nominal_lenght_lc: 'Comprimento nominal Ln',
  length_obtained: 'Comprimento obtion Lc',
  error_lc: 'Erro Lc - Ln',
  value_division: 'Valor de uma divisão',
  item: 'Item',
  circularityChart: 'Gráfico de Circularidade',
  length_indications: 'Indicações de comprimento',
  shape_and_position: 'Parâmetros de forma e posição das superfícies de medição',
  evaluated_parameter: 'Parâmetro avaliado',
  surface_flatness_fixed_side: 'Planeza da superfície no lado fixo',
  surface_flatness_moving_side: 'Planeza da superfície no lado móvel',
  surface_parallelism: 'Paralelismo das superfícies',
  nominal_length: 'Comprimento nominal',
  length_obtained_central: 'Comprimento obtido na região central',
  maximum_minimum_deviations: 'Afastamentos máximo e mínimo do comprimento nominal',
  perpedincunlarity_diagram: 'Diagrama de perpendicularidade',
  applicant_and_service_data: 'Dados do Solicitante e Serviço',
  type_of_square: 'Tipo de esquadro',
  direction_and_side_of_surface: 'Sentido e lado da superfície da medição',
  length_evaluated: 'Comprimento avaliado',
  item_type: 'Tipo do item / classificação',
  regiao_parametro: "Região ou Parâmetro",
  project_code: 'Código do projeto',
  overall_dimensions: 'Dimensões gerais',
  side: 'Lado',
  nominal_diameter: 'Diâmetro nominal',
  maximum_variation: 'Variação máxima',
  average_affective_diameter_of_the_three_wires: 'Diâmetro médio efetivo dos três arames',
  perpendicularity_diagram: 'Diagrama de perpendicularidade',
  results_of_inquiries: 'Resultado das indicações',
  transducer_serial_number: 'Número de série do transdutor',
  indicator_serial_number: 'Número de série do indicador',
  type_of_material: 'Tipo de material',
  applied_traction_force: 'Força de tração aplicada',
  comparator_measuring_range: 'Intervalo de medição do comparador',
  amplifier_measuring_range: 'Intervalo de medição do amplificador',
  standard_deviation: 'Desvio padrão',
  amplifier_serial_number: 'Número de série do amplificador',
  results_evaluated_parameters: 'Resultados dos parâmetros avaliados',
  flank_diameter: 'Diâmetro de flancos',
  step: 'Passo',
  go: 'Passa',
  fillet_angle: 'Ângulo dos filetes',
  diameter_variation: 'Variação do diâmetro',
  scheme: 'Plano',
  circularity_error: 'Erro de circularidade',
  angle_indications: 'Indicações de ângulo',
  doesnt_pass: 'Não Passa',
  repeatability_error: 'Erro de repetitividade',
  hysteresis_error: 'Erro de histerese',
  feed_direction_error: 'Erro do sentido de avanço',
  forward_return_direction_error: 'Erro dos sentidos de avanço e retorno',
  orientative_diagram: 'Diagrama orientativo da distribuição dos pontos e posições calibrados',
  incerteza: 'Incerteza',
  media: 'Média',
  arredondamento: "Arredondamento",
  valor_menor_dvisao: "Valor da menor divisão",
  valueSmallestGraduation: "Value of the smallest graduation",
  valorMenorDivisaoPercent: "Valor da menor divisão",
  faixa_medicao_espectral: "Faixa de medição espectral",
  largura_banda: "Largura de banda",
  software_utilizado: "Software utilizado",
  velocidade_varredura: "Velocidade de varredura",
  comprimento_onda_nm: "Comprimento de onda, em nm",
  escala_fotometrica_uv: "Escala fotométrica ultra violeta (UV), em absorvância",
  escala_fotometrica_vis: "Escala fotométrica visível (VIS), em absorvância",
  parametros_avaliados: "Parâmetros Avaliados",
  afastamento_valor_nominal: "O afastamento do valor nominal é obtido pela diferença entre o valor obtido pelas medições realizadas pelo padrão do laboratório e o valor nominal.",
  imagens_item_medido: "Imágenes del artículo medido:",
  projeto_item_medido: "Diseño del artículo medido:",
  tabela_resultados_detalhada: "Tabla de resultados detallada:",
  especificacao: "Especificação",
  erro_medicao: "O erro de medição é obtido pela diferença entre o valor obtido pelo padrão do laboratório e o valor nominal do item avaliado.",
  valor_divisao: "Valor de uma divisão",
  intervalo_medicao: "Intervalo de medição",
  erro_adjacente: "O erro adjacente é obtido pela diferença dos valores, entre os pontos consecutivos.",
  erro_repetitividade: "O erro de repetitividade é obtido pela máxima variação em uma série de três medições consecutivas.",
  configuracao: "Configuração",
  software_indicador: "Software do indicador",
  versao_software_indicador: "Versão do software do indicador",
  numero_serie_indicador: "Número de série do indicador",
  erro_medicao_equipamento: "O erro de medição é obtido pela diferença entre o valor indicado do equipamento avaliado e o valor de referência.",
  classe_exatidao: "Classe de exatidão",
  tipo_balanca: "Tipo de balança",
  tipo_auto_ajuste: "Tipo de auto ajuste",
  calibracao_excentricidade: "Calibração da excentricidade",
  imagens_orientativas_excentricidade: "Imagens orientativas das posições de medição na calibração da excentricidade",
  desvio_padrao_informado: "O desvio padrão informado corresponde à média das leituras realizadas em cada ponto calibrado.",
  atividade_ajuste_reparo: "A atividade de ajuste ou reparo, quando realizada, não faz parte do escopo da acreditação do laboratório.",
  calibracao_nao_isenta_controle: "Esta calibração não isenta o instrumento do controle metrológico estabelecido na regulamentação metrológica.",
  material_amostra: "Material da Amostra",
  volume: "Volume",
  codigo: "Código",
  histerese: "Histerese é a diferença entre os erros de indicação pontuais da escala dos ciclos ascendentes e descendentes.",
  tipo_escala: "Tipo de escala",
  tipo_nomenclatura: "Tipo de nomenclatura",
  resolucao_adotada: "Resolução adotada",
  sentidos_horario_antihorario: "Os sentidos horário e anti-horário foram definidos observando o nível frontalmente, seguindo as descrições do fabricante e/ou código.",
  zero_inversao: "O zero de inversão foi obtido por meio das medições realizadas nas posições frontal (0°) e posterior (invertida 180°) do instrumento.",
  numero_serie_apalpador: "Número de Série do apalpador",
  numero_serie_braco: "Número de Série do braço",
  ruido_fundo: "O ruído de fundo corresponde à influência do sistema de medição e o ambiente ao seu redor. Foi determinado utilizando um plano óptico de referência, onde seus resultados são utilizados nos cálculos das incertezas de medição dos parâmetros de rugosidade.",
  diagrama_orientativo_distribuicao: "Diagrama orientativo da distribuição dos pontos e posições calibrados",
  tipo_perfil_rugosidade: "Tipo do perfil de rugosidade",
  abertura_nominal: "Abertura nominal",
  diametro_fio_nominal: "Diâmetro do fio nominal",
  sentido_medicao_horizontal: "O sentido de medição horizontal (X) é paralelo à descrição da peneira, identificado no caixilho.",
  classe_declarada: "Classe declarada",
  retrological_characteristics_presented_by_the_instrument: "Características retrologicas apresentadas pelo instrumento",
};
